export default __webpack_public_path__ + "static/media/live4.8c4dd3da.jpeg";